import React from 'react';
import type { IconProps } from '../types';

export const ver2 = (props: IconProps) => (
  <svg
    width="64px"
    height="64px"
    viewBox="0 0 20.00 20.00"
    xmlns="http://www.w3.org/2000/svg"
    fill="#00e1ff"
    stroke="#00e1ff"
    strokeWidth="0.0002"
    {...props}
  >
    <g
      id="SVGRepo_bgCarrier"
      strokeWidth="0"
    />

    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <g id="SVGRepo_iconCarrier">
      {' '}
      <rect
        x="0"
        fill="none"
        width="20"
        height="20"
      />{' '}
      <g>
        {' '}
        <path d="M5 3h14v11h-2v2h-2v2H1V7h2V5h2V3zm13 10V4H6v9h12zm-3-4c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm1 6v-1H5V6H4v9h12zM7 6l10 6H7V6zm7 11v-1H3V8H2v9h12z" />{' '}
      </g>{' '}
    </g>
  </svg>
);

export default ver2;
